import {
  sharedDaDK,
  sharedDeDE,
  sharedEnUS,
  sharedEsES,
  sharedFrFR,
  sharedItIT,
  sharedNbNO,
  sharedNlNL,
  sharedPlPL,
  sharedPtBR,
  sharedPtPT,
  sharedSvSE,
} from '@griply/assets';
import { Locales } from '@griply/types';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {
  daDK,
  deDE,
  enUS,
  esES,
  frFR,
  itIT,
  nbNO,
  nlNL,
  plPL,
  ptBR,
  ptPT,
  svSE,
} from 'shared/assets/localization';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: Locales.EnUS,
    resources: {
      [Locales.EnUS]: { translation: { ...sharedEnUS, ...enUS } },
      [Locales.NlNL]: { translation: { ...sharedNlNL, ...nlNL } },
      [Locales.EsES]: { translation: { ...sharedEsES, ...esES } },
      [Locales.DeDE]: { translation: { ...sharedDeDE, ...deDE } },
      [Locales.PlPL]: { translation: { ...sharedPlPL, ...plPL } },
      [Locales.DaDK]: { translation: { ...sharedDaDK, ...daDK } },
      [Locales.SvSE]: { translation: { ...sharedSvSE, ...svSE } },
      [Locales.NbNO]: { translation: { ...sharedNbNO, ...nbNO } },
      [Locales.ItIT]: { translation: { ...sharedItIT, ...itIT } },
      [Locales.FrFR]: { translation: { ...sharedFrFR, ...frFR } },
      [Locales.PtPT]: { translation: { ...sharedPtPT, ...ptPT } },
      [Locales.PtBR]: { translation: { ...sharedPtBR, ...ptBR } },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
    },
  });

// Update HTML lang attribute when language changes
const updateHtmlLang = (lng: string) => {
  document.documentElement.setAttribute('lang', lng.split('-')[0]);
};

// Set initial language
updateHtmlLang(i18n.resolvedLanguage ?? i18n.language);

// Listen for language changes
i18n.on('languageChanged', updateHtmlLang);

export default i18n;
